module.exports = __webpack_public_path__ + "img/Add.b3ba64eb.svg";